import React from 'react';
import { noop } from 'lodash';

export const createProjectSkeleton = (amount) => [...Array(amount)].map((_, i) => ({ gig_id: i }));

export const createSliderSettings = ({
    slidesToShow,
    breakpoints,
    afterChange = noop,
    isTouch,
    isInfinite = false,
}) => {
    const sliderSettings = {
        dots: false,
        isInfinite,
        speed: 300,
        arrows: !isTouch,
        useArrows: !isTouch,
        nextArrow: <button />,
        prevArrow: <button />,
        centerMode: false,
        slidesToShow,
        slidesToScroll: slidesToShow,
        responsive: [],
        afterChange,
        sliderBreakpoints: breakpoints,
    };

    return sliderSettings;
};
